// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Carbonometro_TransactionsResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /api/public/carbonometro/transactions.
 *
 * Emitted RAW — {pageSize, count, items} is the whole body, there is no
 * {success, dados, error} envelope: the consumer is an external system with
 * its own fixed shape. `count` == count(items); it may exceed `pageSize` (the
 * page never splits a same-second group — see the controller docblock).
 */
import type { Carbonometro_TransactionRow } from './Carbonometro_TransactionRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Carbonometro_TransactionsResponseDados {
pageSize: number
count: number
items: Carbonometro_TransactionRow[]
}

export type Carbonometro_TransactionsResponse = ApiResponse<Carbonometro_TransactionsResponseDados>;

registerResponseContract('Carbonometro_TransactionsResponse', {
  pageSize: { type: 'number',  required: true },
  count:    { type: 'number',  required: true },
  items: {
    type: 'array',
    required: true,
    items: {
      id:        { type: 'string',  required: true },
      customer:  { type: 'string',  required: false },
      service:   { type: 'string',  required: false },
      unit:      { type: 'string',  required: true },
      city:      { type: 'string',  required: false },
      region:    { type: 'string',  required: false },
      country:   { type: 'string',  required: true },
      price:     { type: 'number',  required: true },
      currency:  { type: 'string',  required: true },
      addedTime: { type: 'string',  required: true },
    },
  },
})
